import React from 'react';

import ScrollDownItem from '@/core/components/ScrollDownItem';
import { ConversationsAction } from '@/core/lib/new-architecture/domain/donation.domain';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface ConversationSecondaryActionComponentProps {
  action: ConversationsAction;
}

const ConversationSecondaryActionComponent: React.FC<ConversationSecondaryActionComponentProps> = ({ action }) => {
  const { t } = useTranslationContext(['common']);

  const href = new Routes.ConversationsRoute({
    donations: [action.donationId],
  });

  return <ScrollDownItem type="link" icon="message-square" content={t(action.text, { ns: 'common', count: action.sollicitations })} href={href} />;
};

export default ConversationSecondaryActionComponent;
